import React from "react";
import Flagship from "../../core/flagship";
import { Link } from "react-router";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actions from "../../actions/appActions";
import {
  Table,
  Loader,
  Label,
  Input,
  Icon,
  Menu,
  Button,
  Modal,
  Header
} from "semantic-ui-react";
import { throttle, empty, getFormattedValue } from "../../utils/helpers";
import FilterAssigneeModal from "../modals/FilterAssigneeModal";
import Filters from "../misc/Filters";
import Exporter from "../misc/Exporter";
import moment from "moment-business-days";

class LineItems extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
    this.prevPage = this.prevPage.bind(this);
    this.nextPage = this.nextPage.bind(this);
    this.jumpToPage = this.jumpToPage.bind(this);
    this.filterSearch = this.filterSearch.bind(this);
    this.search = this.search.bind(this);
    this.toggleFiltersVisibility = this.toggleFiltersVisibility.bind(this);
    this.toggleExportVisibility = this.toggleExportVisibility.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
    this.onFilterToggle = this.onFilterToggle.bind(this);
    this.selectAllFilters = this.selectAllFilters.bind(this);
    this.selectAllInGroup = this.selectAllInGroup.bind(this);
    this.selectMultipleFilters = this.selectMultipleFilters.bind(this);
    this.exportPage = this.exportPage.bind(this);
    this.exportData = this.exportData.bind(this);
    this.saveData = this.saveData.bind(this);
    this.exportHeadings = [
      "ID",
      "Name",
      "Type",
      "Market",
      "RFP",
      "Due",
      "Assignee",
      "Price"
    ];
    this.timer = null;

    this.lineItemStatuses = {
      "needs-pricing": {
        label: "Needs Pricing",
        color: "green"
      },
      priced: {
        label: "Priced",
        color: "blue"
      }
    };
  }

  getInitialState() {
    let filterStatus = this.props.location.query.status;
    let orderBy = this.props.location.query.orderby;

    let currentFilters = {};
    if (!empty(filterStatus)) {
      currentFilters.status = filterStatus;
    }
    if (!empty(orderBy)) {
      currentFilters.orderby = orderBy;
    }

    return {
      currentFilters,
      currentPage: 1,
      products: [],
      totalCount: 0,
      totalPages: 1,
      loading: true,
      choosingAssignee: false,
      assigneeFilterName: null,
      filtersVisible: false,
      exportVisible: false,
      expandedFilters: false,
      exporting: false,
      exportProgress: 0
    };
  }

  componentWillMount() {
    setTimeout(Flagship.closeSidebarNav, 500);
  }

  componentDidMount() {
    document.title = "Flagship / Line Items";
    this.getLineItems();
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.route.type !== this.props.route.type ||
      nextProps.instance !== this.props.instance
    ) {
      document.title = "Flagship / Line Items";
      this.setState(this.getInitialState(), this.getLineItems);
    }
  }

  getLineItems() {
    let self = this;

    let data = Object.assign(
      {
        instance: this.props.instance
      },
      this.state.currentFilters
    );

    Flagship.get(
      "line-items/list/" + this.state.currentPage,
      data,
      function(response) {
        if (response.data.success === true) {
          self.setState({
            products: response.data.results,
            totalCount: response.data.totalCount,
            totalPages: Math.ceil(response.data.totalCount / 15),
            loading: false
          });
        } else {
          Flagship.error("Error getting products from Flagship API server.");
        }
      },
      function(err) {
        Flagship.error(
          "Error getting products from Flagship API server: " + err
        );
      }
    );
  }

  prevPage() {
    this.setState(
      {
        currentFilters: [],
        currentPage:
          this.state.currentPage > 1
            ? this.state.currentPage - 1
            : this.state.currentPage
      },
      this.getLineItems
    );
  }

  nextPage() {
    this.setState(
      {
        currentFilters: [],
        currentPage:
          this.state.currentPage < this.state.totalPages
            ? this.state.currentPage + 1
            : this.state.currentPage
      },
      this.getLineItems
    );
  }

  jumpToPage(page) {
    this.setState(
      {
        currentPage: page,
        loading: true
      },
      this.getLineItems
    );
  }

  filterSearch(value) {
    let currentFilters = Object.assign({}, this.state.currentFilters);

    if (value === "") {
      delete currentFilters["search"];
    } else {
      currentFilters["search"] = value;
    }

    this.setState({ currentFilters: currentFilters }, this.getLineItems);
  }

  search(e) {
    e.persist();
    let filterSearch = this.filterSearch;
    this.timer = throttle(
      function() {
        filterSearch(e.target.value);
      },
      500,
      this.timer
    );
  }

  toggleFiltersVisibility() {
    this.setState({
      filtersVisible: !this.state.filtersVisible
    });
  }

  toggleExportVisibility() {
    this.setState({
      exportVisible: !this.state.exportVisible
    });
  }

  clearFilters(parameter = false) {
    let newFilters = Object.assign({}, this.state.currentFilters);

    if (parameter) {
      // Only clear one filter group
      delete newFilters[parameter];
    } else {
      newFilters = [];
    }

    this.setState(
      {
        currentFilters: newFilters
      },
      this.getLineItems
    );
  }

  selectAllInGroup(key, possibleFilters) {
    let newFilters = [];

    if (Array.isArray(possibleFilters[key])) {
      possibleFilters[key].map(item => {
        if (typeof newFilters[key] !== "undefined") {
          newFilters[key].push(item);
        } else {
          newFilters[key] = [item];
        }
      });
    } else {
      Object.keys(possibleFilters[key]).map(item => {
        if (typeof newFilters[key] !== "undefined") {
          newFilters[key].push(item);
        } else {
          newFilters[key] = [item];
        }
      });
    }
    return newFilters;
  }

  selectAllFilters(parameter = false, possibleFilters) {
    let newFilters = Object.assign({}, this.state.currentFilters);
    let self = this;

    if (parameter) {
      newFilters = Object.assign(
        newFilters,
        this.selectAllInGroup(parameter, possibleFilters)
      );
    } else {
      Object.keys(possibleFilters).map(key => {
        newFilters = Object.assign(
          newFilters,
          self.selectAllInGroup(key, possibleFilters)
        );
      });
    }

    this.setState(
      {
        currentFilters: newFilters
      },
      this.getLineItems
    );
  }

  onFilterToggle(filterName, filterKey) {
    let newFilters = Object.assign({}, this.state.currentFilters);

    if (typeof newFilters[filterName] !== "undefined") {
      const index = newFilters[filterName].indexOf(filterKey);
      if (index >= 0) {
        newFilters[filterName].splice(index, 1);
      } else {
        newFilters[filterName].push(filterKey);
      }
    } else {
      newFilters[filterName] = [filterKey];
    }

    this.setState(
      {
        currentFilters: newFilters
      },
      this.getLineItems
    );
  }

  selectMultipleFilters(filterName, selections) {
    let newFilters = Object.assign({}, this.state.currentFilters);
    newFilters[filterName] = selections;

    this.setState(
      {
        currentFilters: newFilters
      },
      this.getLineItems
    );
  }

  getService(key) {
    let service = "";

    Flagship.config.lineItemServices.map(function(element) {
      if (element.hasOwnProperty("subOptions")) {
        let innerFound = element.subOptions.find(function(subElement) {
          return subElement.value === key;
        });
        if (typeof innerFound !== "undefined") {
          service = element.text + " - " + innerFound.text;
        }
      }
      if (element.value === key) {
        service = element.text;
      }
    });
    return service;
  }

  setExpanded(filter, value) {
    if (filter && filter !== "default" && value === true) {
      this.setState({
        expandedFilters: filter
      });
    } else {
      this.setState({
        expandedFilters: false
      });
    }
  }

  saveData() {
    let filename = "LineItems_" + moment().format("MM-DD-YYYY") + ".csv";

    const processRow = function(row) {
      let finalVal = "";
      for (let j = 0; j < row.length; j++) {
        let innerValue = row[j] === null ? "" : row[j].toString();
        if (row[j] instanceof Date) {
          innerValue = row[j].toLocaleString();
        }
        let result = innerValue.replace(/"/g, '""');
        if (result.search(/("|,|\n)/g) >= 0) result = '"' + result + '"';
        if (j > 0) finalVal += ",";
        finalVal += result;
      }
      return finalVal + "\n";
    };

    let csvFile = "";

    csvFile += processRow(this.exportHeadings);

    for (let i = 0; i < this.state.exportData.length; i++) {
      csvFile += processRow(this.state.exportData[i]);
    }

    let blob = new Blob([csvFile], { type: "text/csv;charset=utf-8;" });
    if (navigator.msSaveBlob) {
      // IE 10+
      navigator.msSaveBlob(blob, filename);
    } else {
      let link = document.createElement("a");
      if (link.download !== undefined) {
        // feature detection
        // Browsers that support HTML5 download attribute
        let url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }

  clean(results) {
    // Clean up results
    let data = [];

    results.map(item => {
      data.push([
        "#" + item.line_item_key,
        item.line_item_name,
        item.line_item_type,
        item.market,
        item.record_name + " (#" + item.record_key + ")",
        item.extra3 === "" || item.extra3 === null
          ? "-None-"
          : moment.unix(item.extra3).format("MM/DD/YYYY"),
        item.assignee === "" || item.assignee === null
          ? "Unassigned"
          : item.first_name + " " + item.last_name,
        item.price === null
          ? "Needs Pricing"
          : getFormattedValue(item.price, "money")
      ]);
    });
    return data;
  }

  exportPage(page) {
    let self = this;

    let data = Object.assign(
      {
        instance: this.props.instance,
        pageSize: 250
      },
      this.state.currentFilters
    );

    Flagship.get(
      "line-items/list/" + page,
      data,
      function(response) {
        if (response.data.success === true) {
          let totalPages = Math.ceil(response.data.totalCount / 250);

          let cleanData = self.clean(response.data.results);
          let newExportData = [...self.state.exportData, ...cleanData];
          self.setState(
            {
              exportData: newExportData,
              exportProgress: page / totalPages
            },
            () => {
              if (page < totalPages) {
                self.exportPage(page + 1);
              } else {
                self.setState(
                  {
                    exportProgress: 100,
                    exporting: false
                  },
                  self.saveData
                );
              }
            }
          );
        } else {
          Flagship.error("Error exporting products from Flagship API server.");
        }
      },
      function(err) {
        Flagship.error(
          "Error exporting products from Flagship API server: " + err
        );
      }
    );
  }

  exportData() {
    let self = this;
    this.setState(
      {
        exporting: true,
        exportProgress: 0,
        exportData: []
      },
      () => {
        self.exportPage(1);
      }
    );
  }

  render() {
    let possibleFilters = {
      status: this.lineItemStatuses,
      market: Flagship.config.markets,
      service: Flagship.config.lineItemServices,
      assignee: Flagship.config.userGroups
    };

    const displayBody = () => {
      if (this.state.loading) {
        return (
          <Table.Body>
            <Table.Row>
              <Table.Cell colSpan="6">
                <Loader className="flagship-loader" active inline="centered" />
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        );
      } else if (!this.state.products.length) {
        return (
          <Table.Body>
            <Table.Row className="no-results">
              <Table.Cell colSpan="6">
                <Icon name="thumbs down" size="huge" />
                <h3>Nothing Found.</h3>
                <p>
                  Flagship did not find any products that match the criteria
                  you've selected.
                </p>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        );
      } else {
        let self = this;

        return (
          <Table.Body>
            {typeof this.state.products === "object" &&
            this.state.products !== null
              ? this.state.products.map(function(row, i) {
                  let lineItemLink =
                    "/rfp/view/" +
                    row.record_key +
                    "/focus/" +
                    row.line_item_key;

                  let service = self.getService(row.line_item_type);

                  return (
                    <Table.Row key={i}>
                      <Table.Cell key="name">
                        <Link to={lineItemLink}>
                          {!empty(service) && row.line_item_name !== service ? (
                            <span>
                              {row.line_item_name}
                              <em className="table-secondary">({service})</em>
                            </span>
                          ) : (
                            row.line_item_name
                          )}
                        </Link>
                      </Table.Cell>
                      <Table.Cell key="market">
                        <Link to={lineItemLink}>
                          <Label horizontal>{row.market}</Label>
                        </Link>
                      </Table.Cell>
                      <Table.Cell key="io">
                        <Link to={"/rfp/view/" + row.record_key}>
                          {row.record_name}{" "}
                          <em className="table-secondary">
                            (#{row.record_key})
                          </em>
                        </Link>
                      </Table.Cell>
                      <Table.Cell key="due">
                        <Link to={lineItemLink}>
                          {getFormattedValue(row.extra3, "date")}
                        </Link>
                      </Table.Cell>
                      <Table.Cell key="assignee">
                        <Link to={lineItemLink}>
                          {row.user_id === null ? (
                            <span>
                              <em style={{ color: "#999" }}>(Unassigned)</em>
                            </span>
                          ) : (
                            row.first_name + " " + row.last_name
                          )}
                        </Link>
                      </Table.Cell>
                      <Table.Cell key="price">
                        <Link to={lineItemLink}>
                          {row.price === null ? (
                            <Label color="green">Needs Pricing</Label>
                          ) : (
                            <Label color="blue">
                              {getFormattedValue(row.price, "money")}
                            </Label>
                          )}
                        </Link>
                      </Table.Cell>
                    </Table.Row>
                  );
                })
              : null}
          </Table.Body>
        );
      }
    };

    let currentFilters = this.state.currentFilters;
    let search = this.search;

    const hasActiveFilters = () => {
      if (Object.keys(currentFilters).length < 1) {
        return false;
      }
      let returnVal = false;
      Object.keys(currentFilters).map(function(filter) {
        if (filter !== "instance" && currentFilters[filter].length > 0) {
          returnVal = true;
        }
      });
      return returnVal;
    };

    return (
      <div className="fade-in">
        <div id="view-header-section">
          <h1 className="view-title">RFP Line Items</h1>

          <div className="view-filters">
            {this.state.filtersVisible === true || hasActiveFilters() ? (
              <Button
                onClick={this.toggleFiltersVisibility}
                color="pink"
                className="filter-data filtering-active"
              >
                <Icon name="filter" />
                Filtering Data
              </Button>
            ) : (
              <Button
                onClick={this.toggleFiltersVisibility}
                className="filter-data"
              >
                <Icon name="filter" />
                Filter Data...
              </Button>
            )}

            {this.props.userRole === "admin" ? (
              <Button
                onClick={this.toggleExportVisibility}
                className="export-data"
              >
                <Icon name="download" />
                Export Data...
              </Button>
            ) : null}

            <Button as={Link} to="/rfps" className="view-switch">
              <Icon name="eye" />
              Complete RFPs...
            </Button>
          </div>

          <div className="view-search">
            <Input
              placeholder={"Search " + this.props.route.niceName + "..."}
              onKeyUp={search}
            />
          </div>
        </div>

        {this.state.filtersVisible ? (
          <Modal open={true} closeIcon onClose={this.toggleFiltersVisibility}>
            <Filters
              active={currentFilters}
              possible={possibleFilters}
              expandedFilters={this.state.expandedFilters}
              parameters={{
                status: "Status",
                market: "Market",
                service: "Service",
                assignee: "Assignee"
              }}
              matches={this.state.totalCount}
              onToggle={this.onFilterToggle}
              onSelectNone={this.clearFilters}
              onSelectAll={parameter =>
                this.selectAllFilters(parameter, possibleFilters)
              }
              onSelectMultiple={(group, selections) =>
                this.selectMultipleFilters(group, selections)
              }
              setExpanded={(filter, value) => this.setExpanded(filter, value)}
            />
          </Modal>
        ) : null}

        {this.state.exportVisible ? (
          <Modal open={true} closeIcon onClose={this.toggleExportVisibility}>
            <Exporter
              mainHeading="Export Data"
              onSelectNone={this.clearFilters}
              doExport={this.exportData}
            />
            <Filters
              active={currentFilters}
              possible={possibleFilters}
              expandedFilters={this.state.expandedFilters}
              mainHeading={false}
              parameters={{
                status: "Status",
                market: "Market",
                service: "Service",
                assignee: "Assignee"
              }}
              matches={this.state.totalCount}
              onToggle={this.onFilterToggle}
              onSelectNone={this.clearFilters}
              onSelectAll={parameter =>
                this.selectAllFilters(parameter, possibleFilters)
              }
              onSelectMultiple={(group, selections) =>
                this.selectMultipleFilters(group, selections)
              }
              setExpanded={(filter, value) => this.setExpanded(filter, value)}
            />
          </Modal>
        ) : null}

        {this.state.exporting ? (
          <Modal open={true}>
            <Header>Exporting...</Header>
            <div className="export-progress">
              <div
                className="export-progress-inner"
                style={{ width: this.state.exportProgress * 100 + "%" }}
              >
                <span>{Math.round(this.state.exportProgress * 100)}%</span>
              </div>
            </div>
          </Modal>
        ) : null}

        <Table striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Name</Table.HeaderCell>
              <Table.HeaderCell>Market</Table.HeaderCell>
              <Table.HeaderCell>RFP</Table.HeaderCell>
              <Table.HeaderCell>Due</Table.HeaderCell>
              <Table.HeaderCell>Proposal Strategist</Table.HeaderCell>
              <Table.HeaderCell>Price</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          {displayBody()}
          <Table.Footer>
            <Table.Row>
              <Table.HeaderCell colSpan="6" className="view-pagination">
                <Menu pagination>
                  {this.state.currentPage > 1 ? (
                    <Menu.Item icon onClick={this.prevPage}>
                      <Icon name="chevron left" />
                    </Menu.Item>
                  ) : (
                    <Menu.Item icon disabled>
                      <Icon name="chevron left" />
                    </Menu.Item>
                  )}

                  {this.state.currentPage > 3 ? (
                    <Menu.Item name="1" onClick={() => this.jumpToPage(1)} />
                  ) : null}

                  {this.state.currentPage > 4 ? (
                    <Menu.Item disabled>...</Menu.Item>
                  ) : null}

                  {this.state.currentPage > 2 ? (
                    <Menu.Item
                      name={String(this.state.currentPage - 2)}
                      onClick={() =>
                        this.jumpToPage(this.state.currentPage - 2)
                      }
                    />
                  ) : null}

                  {this.state.currentPage > 1 ? (
                    <Menu.Item
                      name={String(this.state.currentPage - 1)}
                      onClick={() =>
                        this.jumpToPage(this.state.currentPage - 1)
                      }
                    />
                  ) : null}

                  <Menu.Item
                    name={String(this.state.currentPage)}
                    active={true}
                    onClick={() => this.jumpToPage(this.state.currentPage)}
                  />

                  {this.state.currentPage < this.state.totalPages - 1 ? (
                    <Menu.Item
                      name={String(this.state.currentPage + 1)}
                      onClick={() =>
                        this.jumpToPage(this.state.currentPage + 1)
                      }
                    />
                  ) : null}

                  {this.state.currentPage < this.state.totalPages - 2 ? (
                    <Menu.Item
                      name={String(this.state.currentPage + 2)}
                      onClick={() =>
                        this.jumpToPage(this.state.currentPage + 2)
                      }
                    />
                  ) : null}

                  {this.state.currentPage <= 2 &&
                  this.state.currentPage < this.state.totalPages - 3 ? (
                    <Menu.Item
                      name={String(this.state.currentPage + 3)}
                      onClick={() =>
                        this.jumpToPage(this.state.currentPage + 3)
                      }
                    />
                  ) : null}

                  {this.state.currentPage <= 1 &&
                  this.state.currentPage < this.state.totalPages - 4 ? (
                    <Menu.Item
                      name={String(this.state.currentPage + 4)}
                      onClick={() =>
                        this.jumpToPage(this.state.currentPage + 4)
                      }
                    />
                  ) : null}

                  {this.state.currentPage < this.state.totalPages - 4 ? (
                    <Menu.Item disabled>...</Menu.Item>
                  ) : null}

                  {this.state.currentPage < this.state.totalPages - 3 ? (
                    <Menu.Item
                      name={String(this.state.totalPages)}
                      onClick={() => this.jumpToPage(this.state.totalPages)}
                    />
                  ) : null}

                  {this.state.currentPage !== this.state.totalPages ? (
                    <Menu.Item icon onClick={this.nextPage}>
                      <Icon name="chevron right" />
                    </Menu.Item>
                  ) : (
                    <Menu.Item icon disabled>
                      <Icon name="chevron right" />
                    </Menu.Item>
                  )}
                </Menu>
                <div className="total-records">
                  Found {this.state.totalCount}
                  {empty(this.state.currentFilters)
                    ? " total " + this.props.route.niceName + "."
                    : " " +
                      this.props.route.niceName +
                      " matching your search criteria."}
                </div>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
        </Table>

        {this.state.choosingAssignee ? (
          <FilterAssigneeModal
            filterAssignee={(e, value) => {
              this.filterAssignee(e, value);
            }}
            chooseAssignee={value => {
              this.chooseAssignee(value);
            }}
          />
        ) : null}
      </div>
    );
  }
}

LineItems.propTypes = {
  actions: PropTypes.object,
  token: PropTypes.string
};

function mapStateToProps(state) {
  return {
    token: state.main.token,
    instance: state.main.instance,
    userRole: state.main.userRole
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LineItems);



// WEBPACK FOOTER //
// ./src/components/views/LineItems.js